import { render, staticRenderFns } from "./AppRh.vue?vue&type=template&id=423638ac&"
import script from "./AppRh.vue?vue&type=script&lang=js&"
export * from "./AppRh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports